import { GetResponse } from '@customTypes/api/IAMAssignedRole';
import { Endpoints, ServiceAPI } from '@service/index';
import queryKeys from '@src/queries/keys';

import { useQuery } from '../helper/useQuery';

const useGetIAMAssignedPermission = () =>
  useQuery<GetResponse>(
    [queryKeys.getIAMRoles],
    async () => {
      const res = await ServiceAPI.get<void, GetResponse>(
        Endpoints.IAMAssignedPermission(),
      );
      return res.data;
    },
    {
      // Cache for 1 year, practically never expire
      cacheTime: 31556952000,
      refetchOnMount: false,
    },
  );

export default useGetIAMAssignedPermission;
